import { render, staticRenderFns } from "./GateTable.vue?vue&type=template&id=060eb69e"
import script from "./GateTable.vue?vue&type=script&lang=ts"
export * from "./GateTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports